export const SHOULD_AUTO_GENERATE_SMART_CARDS: boolean = false;

export const HEADS_UP_SIDEBAR_HEADER_HEIGHT_PX: number = 64;

export const HEADS_UP_UNLOCK_NOTE_COUNT_THRESHOLD: number = 3;
